import {
    apiRequest,
    // acmanajerialLevel,
    undanganpelantikanDetail
} from "../../../../../services/adapters/kepegawaian/undanganPelantikanService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", undanganpelantikanDetail, {
            params: query
        }, true)
    }

    // fetchLevel = async (query) => {
    //     return await apiRequest("get", acmanajerialLevel, {
    //         params: query
    //     }, true)
    // }
}

export default DetailRepository